"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UPDATE_JOB_PROGRESS_INTERVAL = 500;
var UPDATE_JOB_PROGRESS_MAX_ATTEMPTS = 5;
var OrgEntitlementsExporter = /*#__PURE__*/function () {
  OrgEntitlementsExporter.$inject = ["$scope", "$interval", "modalService", "entitlementsService", "taskQueueService", "ENTITLEMENTS_SERVICE_ENDPOINT"];
  /* @ngInject */
  function OrgEntitlementsExporter($scope, $interval, modalService, entitlementsService, taskQueueService, ENTITLEMENTS_SERVICE_ENDPOINT) {
    _classCallCheck(this, OrgEntitlementsExporter);
    this.$scope = $scope;
    this.$interval = $interval;
    this.modalService = modalService;
    this.entitlementsService = entitlementsService;
    this.taskQueueService = taskQueueService;
    this.entitlementsEndpoint = ENTITLEMENTS_SERVICE_ENDPOINT;
  }
  return _createClass(OrgEntitlementsExporter, [{
    key: "$onInit",
    value: function $onInit() {
      this.loading = false;
      this.jobDocCreated = false;
      this.jobId = null;
      this.jobProgress = 0;
      this.gettingJobProgressFailed = false;
    }

    /**
     * Creates a backgroundjob for the exporter type, and
     * displays a modal showing the progress with a download button when job has finished.
     *
     */
  }, {
    key: "createExport",
    value: function createExport() {
      var _this = this;
      this.loading = true;
      this.modalService.openModal({
        templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-exporter/org-entitlements-exporter-modal.html',
        scope: {
          vm: this
        }
      });
      this.entitlementsService.createEventEntitlementsExportJob(this.type, this.organisation._id).then(function (response) {
        _this.jobDocCreated = true;
        _this.jobId = response.jobId;
        _this.periodicallyUpdateJobProgress(response.jobId);
      }).catch(function (err) {
        _this.jobDocCreated = false;
        console.error('[OrgEntitlementExporter]', 'Error occured', err);
      }).finally(function () {
        _this.loading = false;
      });
    }

    /**
     * Checks the status of the job every UPDATE_JOB_PROGRESS_INTERVAL ms, and
     * updates this.jobProgess accordingly.
     *
     */
  }, {
    key: "periodicallyUpdateJobProgress",
    value: function periodicallyUpdateJobProgress(jobId) {
      var _this2 = this;
      var updateJobProgressAttempts = 0;
      this.jobProgressInterval = this.$interval(function () {
        _this2.taskQueueService.getJobStatus(jobId).then(function (response) {
          _this2.jobProgress = response.progress;
          if (_this2.jobProgress === 100) _this2.$interval.cancel(_this2.jobProgressInterval);
        }).catch(function (err) {
          updateJobProgressAttempts += 1;
          if (updateJobProgressAttempts >= UPDATE_JOB_PROGRESS_MAX_ATTEMPTS) {
            _this2.$interval.cancel(_this2.jobProgressInterval);
            _this2.gettingJobProgressFailed = true;
            console.error('[OrgEntitlementExporter]', 'Error occured', err);
          }
        });
      }, UPDATE_JOB_PROGRESS_INTERVAL);
    }

    /**
     * Returns the link for the exportec excel file for this.type and this.jobId
     *
     */
  }, {
    key: "getDownloadLink",
    value: function getDownloadLink() {
      return "".concat(this.entitlementsEndpoint, "/").concat(this.organisation._id, "/").concat(this.type, ".xlsx/").concat(this.jobId);
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements-exporter', ['backstage.services']).component('bsOrgEntitlementsExporter', {
  template: '<button class="btn btn-primary" ng-click="vm.createExport()">Export XLS</button>',
  bindings: {
    organisation: '<',
    type: '@'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsExporter
}).name;